import script from "./ForcedFocus.vue?vue&type=script&lang=ts"
export * from "./ForcedFocus.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__